// Generated by scripts/build-ui-icons.mjs.
export { PaperPlaneTilt as default } from "../ui/glyphs-5";
